export const trackViewImageModule = promotion => {
  if (!promotion) return
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "view_promotion",
      module_ID: String(promotion.parentId),
      creative_name: promotion.layoutName,
      creative_slot: promotion.positionId
    })
  }
}

export const trackSelectImageModule = promotion => {
  if (!promotion) return
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "select_promotion",
      module_ID: String(promotion.parentId),
      creative_name: promotion.layoutName,
      creative_slot: promotion.positionId
    })
  }
}
